import { IWarning } from '@praktio/common-ui';

export const DEFAULT_API_CONFIG = {
  baseURL: process.env.REACT_APP_API || '/api/v1/',
  timeout: 60000,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
};

export const TENANT_ID = 'praktio';

export const TENANT_API_ENDPOINT = `tenant/${TENANT_ID}`;

export const Jurisdictions = [
  'Alabama',
  'Alaska',
  'Arizona',
  'Arkansas',
  'California',
  'Colorado',
  'Connecticut',
  'Delaware',
  'District of Columbia',
  'Florida',
  'Georgia',
  'Hawaii',
  'Idaho',
  'Illinois',
  'Indiana',
  'Iowa',
  'Kansas',
  'Kentucky',
  'Louisiana',
  'Maine',
  'Maryland',
  'Massachusetts',
  'Michigan',
  'Minnesota',
  'Mississippi',
  'Missouri',
  'Montana',
  'Nebraska',
  'Nevada',
  'New Hampshire',
  'New Jersey',
  'New Mexico',
  'New York',
  'North Carolina',
  'North Dakota',
  'Ohio',
  'Oklahoma',
  'Oregon',
  'Pennsylvania',
  'Puerto Rico',
  'Rhode Island',
  'South Carolina',
  'South Dakota',
  'Tennessee',
  'Texas',
  'Utah',
  'Vermont',
  'Virginia',
  'Washington',
  'West Virginia',
  'Wisconsin',
  'Wyoming',
];

export const Roles: { [key: string]: string } = {
  PlatformAdmin: 'PLATFORM_ADMIN',
  PlatformDelegate: 'PLATFORM_DELEGATE',
  TenantAdmin: 'TENANT_ADMIN',
  TeamManager: 'TEAM_MANAGER',
  Learner: 'LEARNER',
};

export const AssignTargetTypes = {
  Team: 'TEAM',
  User: 'USER',
};

export const None = 'NONE';

export const CellFormats: ICellFormats = {
  checkbox: 'checkbox',
  percent: 'percent',
  date: 'date',
  delete: 'delete',
  edit: 'edit',
  info: 'info',
};

export const ModuleTypes: IModuleTypes = {
  Author: 'AUTHOR',
  Video: 'VIDEO',
  Document: 'DOCUMENT',
  Embedded: 'EMBEDDED',
};

export const Dates: number[] = [
  1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27,
  28,
];

export const Days: IKey = {
  Sunday: 0,
  Monday: 1,
  Tuesday: 2,
  Wednesday: 3,
  Thursday: 4,
  Friday: 5,
  Saturday: 6,
};

export const NotificationFrequency: IKey = {
  Never: 'NEVER',
  Daily: 'DAILY',
  Weekly: 'WEEKLY',
  Monthly: 'MONTHLY',
};

export { MessageTypes } from '@praktio/common-ui';

export const ImageURLs = {
  praktioMakeMistakes: 'https://content.praktio.com/asset/praktio-logo-1630678340047.svg',
  loginImage: 'https://content.praktio.com/asset/login-image-1630352134906.png',
  praktioLogoWhite:
    'https://content.praktio.com/asset/Logo_Secondary_No%20Line_White-1634838895478.png',
};

export const IUserFields = {
  OptOutCLEs: 'optOutCLEs',
};

// This should line up with the error codes defined in the API. At some point, we should
// consider moving these to a common location.
export const ErrorCodes = {
  InvalidPassword: 1,
  SamePassword: 2,
  ExpiredPassword: 3,
  InvalidEmail: 4,
  DuplicateEmail: 5,
  InvalidToken: 6,
  Generic: 7,
  InvalidDomain: 8,
  InvalidConfigName: 9,
  MissingProfile: 10,
  MissingEmail: 11,
  UnmappedUser: 12,
  ReCAPTCHA: 13,
  MaintenanceMode: 14,
  SSOSignature: 15,
  SSOIdpRejected: 16,
  SSOConfigMismatch: 17,
  SSOExpired: 18,
  SSOBadResponse: 19,
};

export const GenericFormWarning: IWarning = {
  title: 'Form Error',
  body: 'Please check your entry and try again.',
};

export const NetworkErrorFormWarning: IWarning = {
  title: 'Network Error',
  body: 'Please try again or contact support@praktio.com for further assistance.',
};

export const LoginEmailWarning: IWarning = {
  title: 'Invalid Email',
  body: 'Please check your email and try again.',
};

export const InvalidEmailAdminWarning: IWarning = {
  title: 'Invalid Email',
  body: 'Please check the email and try again.',
};

export const InvalidPasswordFormWarning: IWarning = {
  title: 'Invalid Password',
  body: 'Please check your password and try again.',
};

export const SamePasswordFormWarning: IWarning = {
  title: 'Invalid Password',
  body: 'Your new password cannot be the same as your old password.',
};

export const DuplicateEmailFormWarning: IWarning = {
  title: 'Duplicate Email',
  body: 'User already exists with the provided email.',
};

export const InvalidEmailFormWarning: IWarning = {
  title: 'Invalid Email',
  body: 'Please check your email and try again.',
};

export const ResetPasswordFormWarning: IWarning = {
  title: 'Reset Password',
  body: 'Set a new password and complete any required fields to continue.',
};

export const CompleteRegistrationFormWarning: IWarning = {
  title: 'Complete Registration',
  body: 'Complete the required fields below to finish registering your account.',
};

export const UnmetReqsFormWarning: IWarning = {
  title: 'Incomplete Required Fields',
  body: 'Complete the required fields below.',
};

export const InvalidTokenWarning: IWarning = {
  title: 'This account has already been registered.',
  body: `Please log in below. If you don't recall your password, you can reset it using the "Forgot password" link.`,
};

export const ForgotPasswordPageFields = {
  email: 'email',
  captcha: 'captcha',
};

export const ResetPasswordPageFields = {
  newPassword: 'newPassword',
  confirmNewPassword: 'confirmNewPassword',
  captcha: 'captcha',
};

export const FormValidationErrors = {
  passwordsDoNotMatch: 'Passwords do not match.',
  notSamePassword: 'Your new password cannot be the same as your old password.',
  emptyPassword: 'You must enter your current password before you can set a new one.',
  cles: `Add your CLE information for at least 1 jurisdiction or select "No".`,
  blank: 'This field cannot be blank.',
  incompleteCaptcha: 'Please complete the Captcha.',
  invalidEmail: 'This entered email is invalid.',
  noReportTeams: 'Please select at least one team.',
  noReportCourses: 'Please select at least one course.',
};

export const APIErrorMessages = {
  invalidPassword: 'Invalid password',
  invalidEmailOrPassword: 'Invalid email or password',
  expiredPassword: 'Expired password',
};

export const RetakeBadgeTooltip = `You've already completed this module and are currently retaking it. Retaking this module will not affect your course completion percentage or the availability of subsequent modules that require completion of this module.`;

export enum SortOrder {
  Ascending = 'asc',
  Descending = 'desc',
}

export enum TableDataTypes {
  String = 'string',
  Date = 'date',
}

// If changing breakpoint sizes here, be sure to also
// change them in variables.scss.
export enum BreakpointSizes {
  MediumBreakpoint = 880,
  LargeBreakpoint = 1268,
}

export const WeDontShareYourScoresBody = `Praktio does not share your "scores" in this course with anyone. If your employer purchased this course for you, Praktio will share your activity data (e.g., how much of the course you have completed) with them but not what you got right or wrong.`;

export const QuickFilterOptions: IKey = {
  NotCompletedCourse: 'Which courses has a learner not completed?',
  NotLoggedIn: 'Who has not logged in?',
  NotLoggedInTwoWeeks: 'Who has not logged in for two weeks?',
  CompletedCourse: 'Who has completed a course?',
};

export enum RightPaneColumns {
  XS = 12,
  MD = 7,
  LG = 5,
}

export const SiteKey =
  process.env.REACT_APP_RECAPTCHA || '6LeFKb8aAAAAAE4ReZAkeU0kIYE_7mpYCtNEijnL';

export const Timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
export const TimezoneOffset = new Date().getTimezoneOffset();
export const TimezoneOffsetMs = TimezoneOffset * 60 * 1000;

// Bulk report details
export const TeamSize = 5;
export const CLESize = 3;

const DynamicHeaders = [];
for (let i = 1; i <= TeamSize; i += 1) {
  DynamicHeaders.push({ Header: `Team${i} [Optional]`, accessor: `team${i}` });
}

DynamicHeaders.push({ Header: 'No CLE [Optional]', accessor: 'noCle' });

for (let i = 1; i <= CLESize; i += 1) {
  DynamicHeaders.push({ Header: `CLE Jurisdiction${i} [Optional]`, accessor: `cleState${i}` });
  DynamicHeaders.push({
    Header: `CLE Jurisdiction${i} License Number [Optional]`,
    accessor: `cleBarNumber${i}`,
  });
}

// Add a column to allow clearing the No CLE setting (optional)
DynamicHeaders.push({ Header: "Clear 'No' CLE [Optional]", accessor: 'clearCle' });

export const BulkUploadHeaders: IHeader[] = [
  { Header: 'Email', accessor: 'email', isId: true },
  { Header: 'First Name', accessor: 'firstName' },
  { Header: 'Last Name', accessor: 'lastName' },
  { Header: 'Password [Optional]', accessor: 'password' },
  { Header: 'Practice Group/Department [Optional]', accessor: 'practiceGroup' },
  { Header: 'Office Location [Optional]', accessor: 'firmOffice' },
  { Header: 'Current Position [Optional]', accessor: 'currentPosition' },
  ...DynamicHeaders,
];

export const BulkEditHeaders: IHeader[] = [
  ...BulkUploadHeaders,
  { Header: 'Update Email', accessor: 'updateEmail' },
];

export const SSOPasswordNotice =
  'These settings affect only your Praktio account password and not any account password with another organization (e.g., your employer).';

export const Panes: IPanes = {
  Teams: 'TEAMS',
};

export const WSMessageTypes: IWSMessageTypes = {
  Heartbeat: 'HEARTBEAT',
  Logout: 'LOGOUT',
  Maintenance: 'MAINTENANCE',
  PresenceSnapshot: 'PRESENCE_SNAPSHOT',
};

export const ModalTypes: IModalTypes = {
  Inactivity: 'INACTIVITY',
  Maintenance: 'MAINTENANCE',
  MaintenanceCountdown: 'MAINTENANCECOUNTDOWN',
  Feedback: 'FEEDBACK',
};

export const LogoutTypes: ILogoutTypes = {
  Normal: 'NORMAL',
  Inactivity: 'INACTIVITY',
  Maintenance: 'MAINTENANCE',
};

export const Thirty = 30;
export const Sixty = 60;
export const Second = 1000;
export const ThirtySeconds = Thirty * Second;
export const Minute = Sixty * Second;
export const ThirtyMinutes = Thirty * Minute;
export const OneHour = Sixty * Minute;
export const OneDay = 24 * OneHour;

// Inactive countdown for displaying logout message of 4 hours
export const InactiveDuration = 4 * OneHour;

export const UnauthedRoutes = /^\/(reset|forgot|signup|register|login|sso|maintenance)$/gi;

export const PlatformMessageTypes = {
  Alert: 'ALERT',
  Form: 'FORM',
};

// ===========================================================================
// Local Storage
// ===========================================================================

export const LOCAL_STORAGE_KEYS = {
  activeTeams: 'activeTeams',
  activeDeselectedCourses: 'activeDeselectedCourses',
};

// ===========================================================================
// Expiration Display Labels
// ===========================================================================

export const ExpirationLabels = {
  NA: 'N/A',
  Indefinite: 'Indefinite',
  NotSet: 'Not Set',
};

// ===========================================================================
// Report Table
// ===========================================================================

export const BLANKS_FILTER = '(blanks)';
export const DEBOUNCE_DELAY = 800;

// ===========================================================================
// Alerts
// ===========================================================================

export const ToastifyNoDefaultStyling = {
  className: 'no-default-styling',
};
